import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { UserAuthService } from 'src/app/services/userAuth/user-auth.service'

/**
 * Route guard that prevents access to routes requiring authentication if the user is not logged in.
 * Redirects unauthenticated users to the login page, preserving the target URL via query params.
 */
export const isLoggedInGuard: CanActivateFn = async (route, state) =>
{
    const userAuth = inject(UserAuthService)
    const router = inject(Router)

    // Check if the user is authenticated
    const isAuthenticated = await userAuth.isAuthenticated()

    // If not authenticated, redirect to login page with the current URL in query parameters
    if (!isAuthenticated)
    {
        const urlTree = router.createUrlTree(['login'], {
            queryParams: {
                state: state.url
            }
        })

        return urlTree
    }

    return true
}